export function getFiltersQuery(filter) {
  let query = "";

  Object.keys(filter).forEach((filterField) => {
    if (filter[filterField]) 
      query += `${filterField}=${filter[filterField]}&`;
  });

  return query;
}